import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmployeesServiceProvider } from '../../api/employees'

const EmployeesService = EmployeesServiceProvider()
const name = 'addEmployeeWithManager'

export default (managerId, employee, alternativeCampaignName) => {
  const data = { managerId, employee }
  if (alternativeCampaignName) {
    data.alternativeCampaignName = alternativeCampaignName
  }
  return asyncAction(
    name,
    EmployeesService.addEmployeeWithManager,
    data
  )
}

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/employee/addEmployeeWithManager.js